<template>
	<div class="dashboard my-5">
		<h1 class="text-center font-weight-bold">Dashboard Admin Eclass</h1>
		<div class="my-5 position-lg-relative">
			<div class="d-block d-lg-flex justify-content-center">
				<div class="card p-2 bg-light border-0" style="width: 18rem;">
					<div class="card-body border-right">
					<h5 class="card-title text-center">Total Users</h5>
					<div class="text-center" v-if="users.length">
						<h1 class="text-primary font-weight-bold">{{users.length}}</h1>
					</div>
						<div class="loader" v-if="showUser"></div>
					</div>
				</div>

				<div class="card p-2 bg-light border-0" style="width: 18rem;">
					<div class="card-body border-right">
					<h5 class="card-title text-center">Total Instructors</h5>
					<div class="text-center" v-if="instructors.length">
						<h1 class="text-primary font-weight-bold">{{instructors.length}}</h1>
					</div>
						<div class="loader" v-if="showInst"></div>
					</div>
				</div>

				<div class="card p-2 bg-light border-0" style="width: 18rem;">
					<div class="card-body">
					<h5 class="card-title text-center">Total Courses</h5>
					<div class="text-center" v-if="courses.length">
						<h1 class="text-primary font-weight-bold">{{courses.length}}</h1>
					</div>
						<div class="loader" v-if="showCourse"></div>
					</div>
				</div>


				
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import App from '@/App'

	export default {
		data(){
			return {
				url: App.data().url,
				users: [],
				instructors: [],
				courses: [],
				showUser: false,
				showInst: false,
				showCourse: false

			}
		},
		mounted(){
			// this.getUsers();
			// this.getInstructor();
			// this.getCourses();
		},
		methods: {
			getUsers(){
				this.showUser = true;
				axios.get(this.url.users).then((res) => {
					res.data.result.map(data => {
						this.users.push(data)
						this.showUser = false;	
					})
				});	
			},
			getInstructor(){
				this.showInst = true;
				axios.get(this.url.instructors).then((res) => {
					if(res.status === 200){
						this.instructors = res.data.result
						this.showInst = false;
					}
				})
			},
			getCourses(){
				this.showCourse = true;
				axios.get(this.url.courses).then((res) => {
					if(res.status === 200){
						this.courses = res.data.result
						this.showCourse = false;
					}
				})
			}
		}
	}
</script>
<style scoped>

	progress[value] {
		max-height: 10px;
	}

	.loader {
		border: 10px solid #f3f3f3;
		border-radius: 50%;
		border-top: 10px solid #007bff;
		border-bottom: 10px solid #007bff;
		width: 50px;
		height: 50px;
		-webkit-animation: spin 2s linear infinite; /* Safari */
		animation: spin 2s linear infinite;
		position: relative;
		left: 35%;

	}

	/* Safari */
	@-webkit-keyframes spin {
		0% { -webkit-transform: rotate(0deg); }
		100% { -webkit-transform: rotate(360deg); }
	}

	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>